import { Validators } from "@angular/forms";
import {
  FieldConfig,
  FieldType,
} from "../../../../shared/components/dynamic-forms-components/field.interface";
import { ALL_REGIONS } from "../../../../store/entities/settings/administrative-area/region/region.graphql";

export const faqFields: FieldConfig[] = [
  {
    type: FieldType.input,
    label: "Question",
    key: "question",
    validations: [
      {
        message: "This field is Required",
        validator: Validators.required,
        name: "required",
      },
    ],
    rowClass: "col-span-12",
  },
  {
    type: FieldType.textarea,
    label: " Answer",
    key: "answer",
    validations: [
      {
        message: "This field is Required",
        validator: Validators.required,
        name: "required",
      },
    ],
    rowClass: "col-span-12",
  },
  {
    type: FieldType.button,
    label: "Save",
    rowClass: "col-span-12",
  },
];
